import { oz } from '@weft/utils';
import { MAX_TO } from './price-tier-schema-consts';

export const PriceTierSchema = oz.object({
  from: oz.number({ invalid_type_error: 'Tier from amount is required' }).nonnegative().max(MAX_TO - 1),
  to: oz.number({ invalid_type_error: 'Tier to amount is required' }).nonnegative().max(MAX_TO),
  price: oz.number({ invalid_type_error: 'Tier price is required', required_error: 'Tier price is required' }).nonnegative(),
  flatRate: oz.number().optional(),
}).openapi('PriceTier');

export type PriceTier = oz.infer<typeof PriceTierSchema>;